export const CardSpacing = {
	lg: 16,
	md: 10,
	sm: 8,
	xs: 8,
};
